import React from 'react'
import styled, { css } from 'styled-components'
import Button from './button'
import Spinner from '../icons/spinner'
import { FaCheck, FaTimes } from 'react-icons/fa'
import { colors } from '../../../styles/theme'

const StyledButton = styled(Button)`
  &,
  &:disabled {
    ${({ status }: { status: ButtonStatus }) => {
      switch (status) {
        case 'error':
          return css`
            background-color: ${colors.danger};
          `
        case 'success':
          return css`
            background-color: ${colors.success};
          `
      }
    }}
  }
`

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto;
  place-items: center;
`

const Content = styled.span`
  grid-area: 1/1/1/1;

  ${({ status }: { status: ButtonStatus }) =>
    status !== 'initial' &&
    css`
      opacity: 0;
    `}
`

const StyledSpinner = styled(Spinner)`
  grid-area: 1/1/1/1;
`

const SuccessIcon = styled(FaCheck)`
  grid-area: 1/1/1/1;
`

const ErrorIcon = styled(FaTimes)`
  grid-area: 1/1/1/1;
`

export type ButtonStatus = 'initial' | 'loading' | 'success' | 'error'

const LoadingButton = ({
  status,
  children,
  ...props
}: { status: ButtonStatus; children: any } & React.ButtonHTMLAttributes<HTMLButtonElement>) => (
  <StyledButton status={status} {...props}>
    <Wrapper>
      <Content status={status}>{children}</Content>
      {status === 'loading' && <StyledSpinner />}
      {status === 'success' && <SuccessIcon />}
      {status === 'error' && <ErrorIcon />}
    </Wrapper>
  </StyledButton>
)

export default LoadingButton
